import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';

import './NewsHomeComponent.css';


function NewsHomeComponentItem({ thumbnailImageUrl, imageUrl, url, name }) {
  return (
    <a className="news-component-item" href={url}>
      <LazyLoad offset={10}>
        <img alt="blogImg" src={thumbnailImageUrl ? thumbnailImageUrl : imageUrl} />
      </LazyLoad>
      <span>{name.toUpperCase()}</span>
    </a>
  );
}

NewsHomeComponentItem.propTypes = {
  imageUrl: PropTypes.string,
  name: PropTypes.string,
  thumbnailImageUrl: PropTypes.string,
  url: PropTypes.string,
};

export default NewsHomeComponentItem;
